import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { useSelector } from "react-redux";
import { useSnackbar } from "notistack";

import { useModelPopup } from "../../../../../common/hooks";
import ConfirmDeleteComponent from "../../../../../common/components/confirmDelete/index";

import { Icon, smSize } from "../../../../../common/icon";

import {
  UserInlineTypes,
  UserInline,
  CompanyAvatar,
  ProjectState,
} from "../../../../primitives";
import styles from "./styles.module.scss";
import isItStandardViewver from "../../../themesCommon/isItStandardViewer";

const ProjectRow = ({
  project,
  isFord,
  selectedCouncilName,
  currentThemeData,
}) => {
  const [hasMore, setHasMore] = useState(false);
  const [showMore, setShowMore] = useState(false);
  const history = useHistory();
  const popup = useModelPopup();
  const { enqueueSnackbar } = useSnackbar();

  const handleProjectRedirect = (id) => {
    history.push(`/projects/${id}/overview`);
  };
  const {
    councilReducer: { selectedCouncil },
    authReducer: { session },
  } = useSelector((state) => state);
  const handleShowMore = () => {
    setShowMore(!showMore);
  };
  useEffect(() => {
    setHasMore(project.companies?.length > 3);
  }, [project.companies]);
  const handleDeleteProject = (themeId, id) => {
    popup.show({
      title: "Confirmation Delete",
      show: true,
      height: "300",
      width: "540",
      component: (
        <ConfirmDeleteComponent
          id={themeId}
          templateId={id}
          enqueueSnackbar={enqueueSnackbar}
          councilId={selectedCouncil?.id}
          actionType="deleteThemeProject"
        />
      ),
    });
  };
  return (
    <div className={styles.gridRow}>
      <div
        className={styles.projectName}
        onClick={() => handleProjectRedirect(project.project.project_id)}
      >
        {project.project.project_name || "-"}
      </div>
      {!isFord && (
        <div className={styles.companies}>
          {project.companies &&
            project.companies.slice(0, showMore ? 50 : 2).map((o) => (
              <div className={styles.company}>
                <div className={styles.firstCol}>
                  <div className={styles.nameContainer}>
                    <div className={styles.companyIcon}>
                      <div className={styles.iconCon}>
                        <CompanyAvatar
                          imgSrc={o.company_logo}
                          name={o.company_name}
                        />
                      </div>
                    </div>
                    <div>{o.company_name}</div>
                  </div>
                  {o.is_product ? (
                    <span className="small text-muted">Product</span>
                  ) : null}
                </div>
              </div>
            ))}
          {hasMore ? (
            <span className={styles.showMore} onClick={handleShowMore}>
              {showMore ? "show less" : "show more..."}
            </span>
          ) : null}
        </div>
      )}
      <div className={styles.cell}>
        {project.project?.project_owners?.map((owner) => {
          return (
            <div className={styles.owner}>
              <UserInline
                className={styles.userIcon}
                userId={owner?.owner_id}
                type={UserInlineTypes.WITH_NAME}
                showMine={false}
                first={owner?.owner_name}
                last={""}
                avatar={owner?.owner_avatar}
                local
              />
            </div>
          );
        })}
      </div>{" "}
      <div className={styles.access}>
        {project.project?.project_access
          ? project.project?.project_access.charAt(0).toUpperCase() +
            project.project?.project_access.slice(1)
          : "-"}
      </div>{" "}
      {selectedCouncilName !== "Firmenich" ? (
        <div className={styles.shortCol}>
          {project.project?.project_stage
            ? project.project?.project_stage
            : "-"}
        </div>
      ) : null}
      <div className={styles.shortCol}>
        {project.project?.project_status ? (
          <ProjectState
            key={project.project?.project_status}
            state={project.project?.project_status}
          />
        ) : (
          "-"
        )}
      </div>
      <div className={styles.shortCol}>
        {isItStandardViewver(session, currentThemeData) && (
          <Icon
            {...smSize}
            icon="icn-button-delete"
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              return handleDeleteProject(
                currentThemeData.id,
                project.project.project_id
              );
            }}
          />
        )}
      </div>
    </div>
  );
};
export default ProjectRow;
